export default __webpack_public_path__ + "static/media/browser-rooms.84c37223.svg";